import { ElementRef } from "@angular/core";
import {ActivatedRoute} from "@angular/router";

export default class ComponentUtils
{
    static getOrgIdFromUrl(url: string, endPart: string): string
    {
      let oIdStr = url.substring(url.indexOf("/org/") + 5, url.indexOf(endPart));
      return oIdStr;
    }

    static getOrgId(route: ActivatedRoute): string
    {
        const oIdStr = route.snapshot.paramMap.get('organization-id');
        return oIdStr ? oIdStr : '';
    }

    static updateElement(
      itemElementRef: ElementRef,
      isActive: boolean,
    ) {
      const iconElement = itemElementRef.nativeElement.querySelector('ion-icon');
      const labelElement = itemElementRef.nativeElement.querySelector('ion-label');
      if (isActive) {
        itemElementRef.nativeElement.classList.add('active');
        if (iconElement) {
          if (iconElement.name.includes('hp-')) iconElement.setAttribute('name', `${iconElement.name}-active`);
          else iconElement.style.color = 'var(--ion-color-secondary-shade)';
        }
        if (labelElement) labelElement.style.color = 'var(--ion-color-secondary-shade)';
      } else {
        itemElementRef.nativeElement.classList.remove('active');
        if (iconElement) {
          if (iconElement.name.includes('hp-')) iconElement.setAttribute('name', iconElement.name.replace('-active', ''));
          else iconElement.style.color = 'var(--ion-color-text)';
        }
        if (labelElement) labelElement.style.color = 'var(--ion-color-text)';
      }
    }

    static extractInitials(str: string) {
      if (!str) return '';
      let words = str.split(' ');
      words = words.filter((word) => word.length > 2 && !word.includes('.'));
      let initials = words.map((word) => word.charAt(0).toUpperCase()).join('');
      return initials;
    }

    static getE164FormattedPhone(phoneNumber: string) {
      return "+1" + phoneNumber;
    }

    static getTimeZone(): string {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
}
